import { onSsoSetup, updateClientDetails } from "core/javascriptChannels";

import { Auth } from "../../../Views/Auth/Auth";
import { AuthVersioningProps } from "core/hooks/useAuthVersioning";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { Login } from "../../../Views/Login/Login";
import { Logout } from "../Logout/Logout";
import { ProtectedRoute } from "../accessControl/ProtectedRoute/ProtectedRoute";
import { ReactElement, useCallback, useMemo } from "react";
import { SsoRedirectState } from "shared/core/state/ssoRedirectState";
import { handleLogout } from "../Logout/handleLogout/handleLogout";
import { useAuth } from "./useAuth/useAuth";
import { useNavigate } from "react-router-dom";

const useAuthModules = (): AuthVersioningProps => {
  const auth = useAuth();
  const navigate = useNavigate();
  const isMobile = useMemo(() => !!window.flutter_inappwebview, []);

  const updateClient = useCallback(() => {
    if (isMobile) {
      updateClientDetails();
    } else {
      navigate("/login", { state: "change_org" });
    }
  }, [isMobile, navigate])

  return {
    auth: (sso?: boolean) => <Auth auth={auth} sso={sso} />,
    Login: () => <Login auth={auth} redirectToHome={isMobile} />,
    Logout: ({ type }: { type?: "nav" | "account" }) => {
      const logout = handleLogout(auth);

      return <Logout type={type} handleLogout={logout} />;
    },
    protect: (el: ReactElement): ReactElement => (
      <ProtectedRoute auth={auth} handleShouldAuthenticate={isMobile ? auth.signinRedirect : undefined} allowRefresh={isMobile}>
        {el}
      </ProtectedRoute>
    ),
    updateClient,
    handleSsoSetup: (provider?: string) => {
      if (isMobile) {
        SsoRedirectState.set("true");
        provider && onSsoSetup(provider.toLowerCase());
      } else {
        auth.signinRedirect({ redirect_uri: `${window.location.origin}/auth/sso`, extraQueryParams: { client_code: ClientInfoState.getCode() } });
      }
    },
  };
};

export const AuthModulesV2 = (): AuthVersioningProps => {
  const modules = useAuthModules();

  return modules;
};
